import SvgIconStyle from '../components/SvgIconStyle';

export const getNavbarIcon = (name: string) => (
  <SvgIconStyle src={`/static/img/icons/navbar/${name}.svg`} />
);

export const getIcon = (name: string, width?:string) => (
  <SvgIconStyle width={width} src={`/static/img/icons/${name}.svg`} />
);
